import { Environments, PartialServiceMap } from '@innovyze/lib_get_service';

const config: PartialServiceMap = {
	// Sample config for overwritting service endpoints
	[Environments.LOCAL]: {
		amRisk: 'https://saas-risk-management.info360-dev.com/dev',
		looker: 'http://localhost:3276/dev/looker',
		amUpload: 'https://saas-upload-service.info360-dev.com/dev',
		export: 'https://saas-export-service.info360-dev.com/dev',
	},
};

export const apiEnv =
	(localStorage.getItem('apiEnv') as keyof typeof Environments) || undefined;

export default config;
